import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useResizeObserver } from '../../hooks';
import { Document, Page, pdfjs } from 'react-pdf';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

// "pdfjs-dist": "^3.11.174",
// "react-pdf": "^5.7.2",

// import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();

// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = ({
    file,
    onDocumentLoadSuccess,
    onDocumentLoadError,
    searchText,
    pageNumber
}) => {
    const [numPages, setNumPages] = useState(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const containerRef = useRef(null);
    const [visiblePageNumbers, setVisiblePageNumbers] = useState({
        from: 1,
        to: numPages
    })

    // array of page numbers to show in pdf
    const pages = useMemo(()=> new Array(visiblePageNumbers.to - visiblePageNumbers.from + 1).fill().map((_, index)=> visiblePageNumbers.from + index), [visiblePageNumbers]);

    useResizeObserver(containerRef.current, (ref) => {
        setContainerWidth(ref.width);
    });

    const handleDocumentLoadSuccess = useCallback((e) => {
        const { numPages } = e;
        setNumPages(numPages);
        onDocumentLoadSuccess && onDocumentLoadSuccess(e)
    }, [onDocumentLoadSuccess])

    const handleCustomTextRenderer = useCallback((e) => {
        const { str: text } = e;
        if (!searchText || !text) {
            return text;
        }

        const searchTerms = (Array.isArray(searchText) ? searchText : searchText.split('\n')).map(term => term.trim()).filter(Boolean);

        if (searchTerms.length === 0) {
            return text;
        }

        const escapedSearchTerms = searchTerms.map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
        const regex = new RegExp(`(${escapedSearchTerms.join('|')})`, 'gi');
        const parts = text.split(regex);
        const lowerCaseSearchTerms = searchTerms.map(term => term.toLowerCase());

        return parts.map((part, i) =>
            part && lowerCaseSearchTerms.includes(part.toLowerCase()) ? <mark key={i}>{part}</mark> : part
        );
    }, [searchText]);

    useEffect(() => {
        // default value
        let from = 1;
        let to = numPages || 1;

        if(pageNumber){
            if(!isNaN(pageNumber)){
                // if page number number then open that page only
                from = +pageNumber;
                to = +pageNumber;
            }else if(pageNumber.toString().includes('-')){
                // handle range
                const rangeArr = pageNumber.toString().split('-')
                if(rangeArr.length === 2 && rangeArr.every(num => !isNaN(num))){
                    from = +rangeArr[0]
                    to = +rangeArr[1]
                }
            }else{
                console.log('Invalid page number')
            }
        }

        setVisiblePageNumbers({
            from,
            to
        })
    }, [numPages, pageNumber])
    
    return (
        <div className='bimmatch-pdf-viewer' ref={containerRef}>
            <Document 
                file={file}
                onLoadSuccess={handleDocumentLoadSuccess}
                onLoadError={onDocumentLoadError}
            >
                {pages.map(pageNumber => (
                    <Page 
                        key={`page_${pageNumber}`} 
                        pageNumber={pageNumber} 
                        customTextRenderer={handleCustomTextRenderer}
                        width={containerWidth}
                    />
                ))}
            </Document>
        </div>
    )
}

export default PdfViewer